import QuoteBlock from './QuoteBlock';
export {QuoteBlockText} from './QuoteBlockText';

export default QuoteBlock;